<script setup>
import { ref, computed } from 'vue';
import KanbanColumn from './KanbanColumn.vue';

const props = defineProps({
  stages: { type: Array, required: true },
  cards: { type: Array, required: true },
});
const emit = defineEmits(['move', 'card-click', 'add-stage', 'add-card', 'edit-stage', 'delete-stage']);

const orderedStages = computed(() =>
  [...props.stages].sort((a, b) => a.position - b.position)
);

function cardsForStage(stageId) {
  return props.cards
    .filter(c => c.stage_id === stageId && !c.archived)
    .sort((a, b) => a.position - b.position);
}

function handleMove({ cardId, stageId, position }) {
  emit('move', { cardId, stageId, position });
}

const newStageName = ref('');
const showAddStage = ref(false);

function submitNewStage() {
  const name = newStageName.value.trim();
  if (!name) return;
  emit('add-stage', { name, position: orderedStages.value.length });
  newStageName.value = '';
  showAddStage.value = false;
}
</script>

<template>
  <div class="flex-1 overflow-x-auto overflow-y-hidden">
    <div class="flex gap-3 h-full min-w-max pb-2">
      <KanbanColumn
        v-for="stage in orderedStages"
        :key="stage.id"
        :stage="stage"
        :cards="cardsForStage(stage.id)"
        @move="handleMove"
        @card-click="$emit('card-click', $event)"
        @add-card="$emit('add-card', $event)"
        @edit-stage="$emit('edit-stage', $event)"
        @delete-stage="$emit('delete-stage', $event)"
      />

      <div class="w-72 flex-shrink-0 flex flex-col">
        <button
          v-if="!showAddStage"
          class="w-full px-3 py-2 rounded-lg border-2 border-dashed border-n-weak text-sm text-n-slate-10 hover:border-n-brand hover:text-n-brand transition-colors"
          @click="showAddStage = true"
        >
          + Adicionar etapa
        </button>
        <div
          v-else
          class="bg-n-solid-1 rounded-lg border border-n-weak p-3 space-y-2"
        >
          <input
            v-model="newStageName"
            class="w-full px-2 py-1.5 text-sm rounded border border-n-weak bg-transparent text-n-slate-12"
            placeholder="Nome da etapa…"
            autofocus
            @keyup.enter="submitNewStage"
            @keyup.esc="showAddStage = false"
          />
          <div class="flex gap-1">
            <button
              class="flex-1 px-2 py-1 rounded bg-n-brand text-white text-sm disabled:opacity-50"
              :disabled="!newStageName.trim()"
              @click="submitNewStage"
            >
              Criar
            </button>
            <button
              class="px-2 py-1 rounded border border-n-weak text-sm text-n-slate-11"
              @click="showAddStage = false"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
